import $ from 'jquery';
import { scrollTo } from '../core/ScrollService.js';
const initFaqMobile = () => {
    let button = document.querySelector('.header_filtersMobileButton');
    let filtersWrap = document.querySelector('.mobileFilters');
    let filtersClose = filtersWrap.querySelector('.mobileFilters_close');
    let filtersFields = filtersWrap.querySelectorAll('.mobileFilters_field');

    button.addEventListener('click', (e) => {
        filtersWrap.classList.add('active');
    });

    filtersClose.addEventListener('click', (e) => {
        filtersWrap.classList.remove('active');
    });

    filtersFields.forEach((fieldElt) => {
        let items = fieldElt.querySelectorAll('.mobileFilters_field_list a');

        items.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let category = link.getAttribute('data-category');
                let elt = document.querySelector('.faqCategory[data-category="' + category + '"]');
                filtersWrap.classList.remove('active');
                scrollTo(elt, -50);
            });
        })
    });

};

export { initFaqMobile };
